import type {RecordEditation} from 'src/typings';
import type {RecordEditationAction} from '../types';
import type {Observable} from 'rxjs';

/**
 * @name GenericEditationAction
 * @class
 * @abstract
 * @description abstract class implementing shared parts of {@link RecordEditationAction}
 */
export abstract class GenericEditationAction implements RecordEditationAction {
    readonly #type: string;

    protected constructor(type: string) {
        this.#type = type;
    }

    public abstract executeAction(editationObject: RecordEditation): Observable<RecordEditation>;

    public equals(otherAction: RecordEditationAction): boolean {
        return this === otherAction;
    }

    public get type() {
        return this.#type;
    }
}